(ns superadmin.roles.table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [cljs-bean.core :refer [->clj]]
            [clojure.string :as str]
            [common.queries :refer [use-query]]
            [common.widgets.data-grid :as dg]
            [common.widgets.page :as page]
            [re-frame.core :as rf]
            [superadmin.roles.create.view]
            [superadmin.roles.ocp.view]
            [superadmin.roles.queries :as q]
            [uix.core :as uix :refer [$ defui]]))

(defn- format-allowed-scopes [scopes]
  (if (seq scopes)
    (str/join ", " (map str/capitalize scopes))
    "Superadmin"))

(def ^:private columns
  #js [#js {:field "name"
            :headerName "Role Name"
            :type "string"
            :minWidth 180
            :flex 2
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:name row))}
       #js {:field "allowed-scopes"
            :headerName "Allowed Scopes"
            :type "string"
            :minWidth 150
            :flex 1.5
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (format-allowed-scopes (:allowed-scopes row)))}])

(defn- get-row-id [row]
  (:id row))

(defui role-data-grid []
  (let [{:keys [data isPending]} (use-query (q/roles-query))
        page-size 10
        initial-state (uix/use-memo
                       (fn []
                         #js {:sorting #js {:sortModel #js [#js {:field "name" :sort "asc"}]}
                              :pagination #js {:paginationModel #js {:pageSize page-size}}})
                       [page-size])
        on-row-click (uix/use-callback
                      (fn [^js params]
                        (let [row (->clj (.-row params))]
                          (rf/dispatch [:ocp/open {:id :role/detail
                                                   :props {:role row}}])))
                      [])]
    ($ DataGridPremium
       {:columns columns
        :loading isPending
        :rows (to-array data)
        :getRowId get-row-id
        :onRowClick on-row-click
        :pagination true
        :pageSizeOptions #js [page-size]
        :initialState initial-state
        :slots #js {:toolbar dg/grid-toolbar}
        :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input}
        :data-testid "table-v2-roles"
        :noWrap true
        :sx #js {:maxHeight "70rem"
                 :cursor "pointer"}})))

(defui roles-page []
  ($ page/page
     ($ page/page-header
        {:title "Roles"
         :buttons ($ Button
                     {:variant "contained"
                      :onClick #(rf/dispatch [:ocp/open {:id :role/create-edit
                                                         :props {}}])
                      :data-testid "create-role-button"}
                     "Create Role")})
     ($ page/content-padding {:sx #js {:overflow "hidden"}}
        ($ role-data-grid))))